import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from "react";
import Button from "../../../../Button";
import { ButtonWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ButtonAdornment(_ref) {
  var label = _ref.label,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    children: /*#__PURE__*/_jsx(Button, _extends({
      size: "compact"
    }, restProps, {
      children: label
    }))
  });
}